export default __webpack_public_path__ + "static/media/pic1.7eb2d9df.webp";